import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const siteUrl = "https://www.anchmarmarine.com";
const defaultImage = `${siteUrl}/logo512.png`;

const seoByPath = {
  "/": {
    title: "Anchmar Marine | Yacht Survey, Marine Surveyor ve Teknik Danışmanlık",
    description:
      "Anchmar Marine; yat surveyi, pre-purchase survey, tekne bakım, arıza tespiti ve denizcilik teknik danışmanlık hizmetleri sunar.",
  },
  "/hakkimizda": {
    title: "Hakkımızda | Anchmar Marine and Consulting",
    description:
      "Anchmar Marine'in yat surveyi, bakım-onarım ve denizcilik mühendisliği danışmanlığı alanındaki yaklaşımını inceleyin.",
  },
  "/hizmetlerimiz": {
    title: "Yat Survey ve Denizcilik Hizmetleri | Anchmar Marine",
    description:
      "Yat surveyi, kondisyon surveyi, hasar tespiti, sigorta surveyi, periyodik bakım, arıza tespiti ve yedek parça hizmetleri.",
  },
  "/fiyatlar": {
    title: "Yat Survey Fiyatları ve Bakım Ücretleri | Anchmar Marine",
    description:
      "Yat survey fiyatları, motor mekanik bakım, arıza tespit, vinç bakımı, ırgat bakımı ve mühendislik danışmanlığı ücretleri.",
  },
  "/documents": {
    title: "Sertifikalar ve Örnek Survey Raporları | Anchmar Marine",
    description:
      "Anchmar Marine sertifikaları ve yat survey hizmetleri için örnek teknik raporları inceleyin.",
  },
  "/iletisim": {
    title: "İletişim | Anchmar Marine Yacht Survey",
    description:
      "Yat surveyi, tekne bakım, arıza tespiti ve mühendislik danışmanlığı için Anchmar Marine ile iletişime geçin.",
  },
};

function setMeta(selector, attr, value) {
  const tag = document.head.querySelector(selector);
  if (tag) {
    tag.setAttribute(attr, value);
  }
}

function Seo() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const seo = seoByPath[path] || seoByPath["/"];
    const canonical = `${siteUrl}${path === "/" ? "" : path}`;

    document.title = seo.title;
    setMeta('meta[name="description"]', "content", seo.description);
    setMeta('meta[property="og:title"]', "content", seo.title);
    setMeta('meta[property="og:description"]', "content", seo.description);
    setMeta('meta[property="og:url"]', "content", canonical);
    setMeta('meta[property="og:image"]', "content", defaultImage);
    setMeta('meta[name="twitter:title"]', "content", seo.title);
    setMeta('meta[name="twitter:description"]', "content", seo.description);
    setMeta('meta[name="twitter:image"]', "content", defaultImage);

    const canonicalTag = document.head.querySelector('link[rel="canonical"]');
    if (canonicalTag) {
      canonicalTag.setAttribute("href", canonical);
    }
  }, [location.pathname]);

  return null;
}

export default Seo;
